localStorage.setItem("blm-filter", "");
localStorage.setItem("blm-colors", "false");
localStorage.setItem("blm-review-stars", "false");

let plpSelectorWithFacets = "";
let plpSelectorResultsWithFacets = "";
let plpSelectorDynamicFilter = "";
let plpMobileFilterButton = "";

if (window.location.search.indexOf("search?q=") != -1) {
  plpSelectorWithFacets = ".blm-product-search.with-facets";
  plpSelectorResultsWithFacets = ".blm-product-search.blm-results.with-facets";
  plpSelectorDynamicFilter = ".blm-product-search .blm-dynamic-filter";
  plpMobileFilterButton =
    ".blm-product-search .blm-product-search-control-button";
} else {
  plpSelectorWithFacets = ".blm-category.with-facets";
  plpSelectorResultsWithFacets = ".blm-category.blm-results.with-facets";
  plpSelectorDynamicFilter = ".blm-category .blm-dynamic-filter";
  plpMobileFilterButton = ".blm-category .blm-product-search-control-button";
}

const isElementLoaded = async (selector) => {
  while (document.querySelector(selector) === null) {
    await new Promise((resolve) => requestAnimationFrame(resolve));
  }
  return document.querySelector(selector);
};

window.addEventListener("click", function () {
  var target = document.querySelector(".blm-has-loaded");
  var observer = new MutationObserver(function (mutations) {
    isElementLoaded(".blm-results").then((selector) => {
      init();
      isElementLoaded(".with-facets").then((selector) => {
        window.jQuery(".filter-toggle-button").click(function (e) {
          sidebarStyles();
          showHideFilter();
          e.stopPropagation();
          e.stopImmediatePropagation();

          var sb = document.querySelector(".blm-product-search-sidebar");
          var wf = document.querySelector(plpSelectorWithFacets);

          if (localStorage.getItem("blm-filter") === "visible") {
            window
              .jQuery(".blm-category.blm-results.with-facets.visible")
              .removeClass("visible");
            window
              .jQuery(".blm-product-search-sidebar.visible")
              .removeClass("visible");
            sb?.setAttribute(
              "style",
              "flex-shrink:0 !important; width:0; overflow: hidden !important;"
            );
            wf?.setAttribute(
              "style",
              "grid-template-columns: 0 1fr !important;"
            );
            localStorage.setItem("blm-filter", "");
          } else {
            window.jQuery(plpSelectorResultsWithFacets).addClass("visible");
            window.jQuery(".blm-product-search-sidebar").addClass("visible");
            window
              .jQuery(".blm-category.blm-results.with-facets.visible")
              .removeAttr("style");
            window
              .jQuery(".blm-product-search-sidebar.visible")
              .removeAttr("style");
            localStorage.setItem("blm-filter", "visible");
          }
        });
      });

      observer.disconnect();
    });
  });

  // Pass in the target node, as well as the observer options.
  observer.observe(target, {
    attributes: true,
    childList: true,
  });
});

loadColorSwatches();
loadReviewStars();
loadHoverImages();
setMobileFilterButton();

$(document).on(
  "click",
  ".blm-product-search-pagination__page button",
  function (e) {
    var sb = document.querySelector(".blm-product-search-sidebar");
    var wf = document.querySelector(plpSelectorWithFacets);
    const filterWasOpen =
      sb.classList.contains("visible") && wf.classList.contains("visible");
    setTimeout(() => {
      const filterButton = document.querySelector(".filter-toggle-button");
      const handleFilterClick = function (e) {
        if (localStorage.getItem("blm-filter") === "visible") {
          document
            .querySelector(plpSelectorResultsWithFacets)
            .classList.remove("visible");
          document
            .querySelector(".blm-product-search-sidebar")
            .classList.remove("visible");
          localStorage.setItem("blm-filter", "");
        } else {
          document
            .querySelector(plpSelectorResultsWithFacets)
            .classList.add("visible");
          document
            .querySelector(".blm-product-search-sidebar")
            .classList.add("visible");
          localStorage.setItem("blm-filter", "visible");
        }
      };
      filterButton.addEventListener("click", handleFilterClick, true);

      if (filterWasOpen) {
        filterButton.click();
      }
    }, 1000);
  }
);

$(document).ready(function () {
  sidebarStyles();
});

if (window.matchMedia("screen and (min-width: 1200px)").matches) {
  isElementLoaded(".blm-results").then((selector) => {
    init();
  });

  isElementLoaded(".with-facets").then((selector) => {
    window.jQuery(".filter-toggle-button").click(function (e) {
      sidebarStyles();
      showHideFilter();
      e.stopPropagation();
      e.stopImmediatePropagation();
    });
  });

  function sidebarStyles() {
    var sb = document.querySelector(".blm-product-search-sidebar");
    var wf = document.querySelector(plpSelectorWithFacets);

    if (localStorage.getItem("blm-filter") === "visible") {
      sb.removeAttribute(
        "style",
        "flex-shrink:0 !important; width:0; overflow: hidden !important;"
      );
      wf.removeAttribute("style", "grid-template-columns: 0 1fr !important;");
      document
        .querySelector(plpSelectorResultsWithFacets)
        .classList.remove("visible");
      document
        .querySelector(".blm-product-search-sidebar")
        .classList.remove("visible");
      localStorage.setItem("blm-filter", "");
    } else {
      sb?.setAttribute(
        "style",
        "flex-shrink:0 !important; width:0; overflow: hidden !important;"
      );
      wf?.setAttribute("style", "grid-template-columns: 0 1fr !important;");

      localStorage.setItem("blm-filter", "visible");
    }
  }

  function showHideFilter() {
    if (localStorage.getItem("blm-filter") === "visible") {
      document
        .querySelector(plpSelectorResultsWithFacets)
        .classList.remove("visible");
      document
        .querySelector(".blm-product-search-sidebar")
        .classList.remove("visible");
      localStorage.setItem("blm-filter", "");
    } else {
      document
        .querySelector(plpSelectorResultsWithFacets)
        .classList.add("visible");
      document
        .querySelector(".blm-product-search-sidebar")
        .classList.add("visible");
      localStorage.setItem("blm-filter", "visible");
    }
  }
} else {
  reloadLeftNav();
}

function setMobileFilterButton() {
  isElementLoaded("#filter-items").then((selector) => {
    if (
      window
        .jQuery(".blm-product-search-sidebar-content")
        .hasClass("blm-open") &&
      document.querySelector(plpMobileFilterButton)
    ) {
      document.querySelector(plpMobileFilterButton).style.display =
        "block!important";
    } else {
      document.querySelector(plpMobileFilterButton).style.display = "none";
    }

    window.jQuery("#filter-items").on("click", function (e) {
      document
        .getElementsByClassName(
          "blm-product-search-control-button blm-product-search-control-button--sidebar"
        )[0]
        .click();
      e.stopPropagation();
      e.stopImmediatePropagation();
    });
  });

  /*setTimeout(() => {
      document.getElementById('filter-items').addEventListener('click', function(e) {
        document.getElementsByClassName("blm-product-search-control-button blm-product-search-control-button--sidebar")[0].click();
      });
    }, "800"); */

  function isMobileWindow() {
    const maxMobileWidth = 768;
    return window.innerWidth <= maxMobileWidth;
  }

  const aside = document.querySelector("aside");

  if (isMobileWindow() && aside) {
    const selectedFilters = aside.querySelector(
      ".blm-product-search-selected-filters"
    );
    if (selectedFilters) {
      const refineByButton = aside.querySelector(
        "button.blm-product-search-control-button"
      );
      aside.style.width = "100%";
      refineByButton.style.display = "none";
    }
  }
  if (!isMobileWindow() && aside) {
    const selectedFilters = aside.querySelector(
      ".blm-product-search-selected-filters"
    );
    if (selectedFilters) {
      const button = document.querySelector(".filter-toggle-button"); // select the button element
      button.addEventListener("click", handleFilterClick, true);
      function handleFilterClick(e) {
        setProductResultHeight();

        if (localStorage.getItem("blm-filter") === "visible") {
          document
            .querySelector(plpSelectorResultsWithFacets)
            .classList.remove("visible");
          document
            .querySelector(".blm-product-search-sidebar")
            .classList.remove("visible");
          localStorage.setItem("blm-filter", "");
        } else {
          document
            .querySelector(plpSelectorResultsWithFacets)
            .classList.add("visible");
          document
            .querySelector(".blm-product-search-sidebar")
            .classList.add("visible");
          localStorage.setItem("blm-filter", "visible");
        }
      }
    }
  }
}

function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

function loadHoverImages() {
  if (!isMobileDevice()) {
    window.jQuery(".blm-product-search-swatch-image").hover(
      function () {
        window
          .jQuery(this)
          .find(".blm-product-search-image-container__hover-image")
          .addClass("show");
      },
      function () {
        window
          .jQuery(this)
          .find(".blm-product-search-image-container__hover-image")
          .removeClass("show");
      }
    );
  }
}

function reloadLeftNav() {
  setTimeout(() => {
    localStorage.setItem("blm-colors", "false");
    localStorage.setItem("blm-review-stars", "false");
    loadColorSwatches();
    loadReviewStars();
    loadHoverImages();
    setMobileFilterButton();
    setProductResultHeight();
    // setMobileFilterCloseButtonInCheckboxAndPriceRangeInputs();
    setMobileCloseFilterButton();
  }, "1500");
}

function loadColorSwatches() {
  if (localStorage.getItem("blm-colors") === "false") {
    /*Color Swatches*/
    window.jQuery(plpSelectorDynamicFilter).each(function (index, element) {
      if (window.jQuery(this).text().toLowerCase().indexOf("colors") !== -1) {
        let color = "";
        window
          .jQuery(this)
          .find(".blm-product-search-filter-item__name")
          .each(function (subIndex, subElement) {
            color = window.jQuery(subElement).text().trim().toLowerCase();
            if (
              window.jQuery(this).context.innerHTML.indexOf("blm-swatch") == -1
            ) {
              window
                .jQuery(this)
                .prepend("<span class='blm-swatch " + color + "'></span>");
              localStorage.setItem("blm-colors", "true");
            }
          });
      }
    });
  }
}

function loadReviewStars() {
  if (localStorage.getItem("blm-review-stars") === "false") {
    /*Review Stars*/
    window.jQuery(plpSelectorDynamicFilter).each(function (index, element) {
      if (window.jQuery(this).text().toLowerCase().indexOf("reviews") !== -1) {
        let star = "";
        window
          .jQuery(this)
          .find(".blm-product-search-filter-item__name")
          .each(function (subIndex, subElement) {
            star = window.jQuery(subElement).text().trim().toLowerCase();
            //console.log(star );
            if (
              window.jQuery(this).context.innerHTML.indexOf("blm-star") == -1
            ) {
              if (star === "5") {
                window
                  .jQuery(this)
                  .prepend(
                    "<span class='fa fa-star checked'><span class='fa fa-star checked'><span class='fa fa-star checked'><span class='fa fa-star checked'><span class='fa fa-star checked'><span class='blm-star " +
                      star +
                      "'></span>"
                  );
              } else if (star.indexOf("4") != -1) {
                window
                  .jQuery(this)
                  .prepend(
                    "<span class='fa fa-star checked'><span class='fa fa-star checked'><span class='fa fa-star checked'><span class='fa fa-star checked'><span class='blm-star " +
                      star +
                      "'></span>"
                  );
              } else if (star.indexOf("3") != -1) {
                window
                  .jQuery(this)
                  .prepend(
                    "<span class='fa fa-star checked'><span class='fa fa-star checked'><span class='fa fa-star checked'><span class='blm-star " +
                      star +
                      "'></span>"
                  );
              } else if (star.indexOf("2") != -1) {
                window
                  .jQuery(this)
                  .prepend(
                    "<span class='fa fa-star checked'><span class='fa fa-star checked'><span class='blm-star " +
                      star +
                      "'></span>"
                  );
              } else {
                window
                  .jQuery(this)
                  .prepend(
                    "<span class='fa fa-star checked'><span class='blm-star " +
                      star +
                      "'></span>"
                  );
              }

              localStorage.setItem("blm-review-stars", "true");
            }
          });
      }
    });
  }
}

function init() {
  /*if(localStorage.getItem("blm-filter") == "hide" && (window.location.search.indexOf("fq")!=-1 || window.location.search.indexOf("page")!=-1) && counter == 0) {
    return
  }*/
  var sb = document.querySelector(".blm-product-search-sidebar");
  var wf = document.querySelector(plpSelectorWithFacets);
  sb?.setAttribute(
    "style",
    "flex-shrink:0 !important; width:0; overflow: hidden !important;"
  );
  wf?.setAttribute("style", "grid-template-columns: 0 1fr !important;");
  localStorage.setItem("blm-filter", "");

  if (window.matchMedia("screen and (min-width: 1200px)").matches) {
    if (localStorage.getItem("blm-filter") === "visible") {
      document
        .querySelector(plpSelectorResultsWithFacets)
        .classList.add("visible");
      document
        .querySelector(".blm-product-search-sidebar")
        .classList.add("visible");
    } else {
      var sb = document.querySelector(".blm-product-search-sidebar");
      var wf = document.querySelector(plpSelectorWithFacets);
      sb?.setAttribute(
        "style",
        "flex-shrink:0 !important; width:0; overflow: hidden !important;"
      );
      wf?.setAttribute("style", "grid-template-columns: 0 1fr !important;");
      localStorage.setItem("blm-filter", "");
    }
  }

  reloadLeftNav();

  const button = document.querySelector(".filter-toggle-button"); // select the button element
  button.addEventListener("click", handleFilterClick, true);

  function handleFilterClick(e) {
    setProductResultHeight();

    if (localStorage.getItem("blm-filter") === "visible") {
      document
        .querySelector(plpSelectorResultsWithFacets)
        .classList.remove("visible");
      document
        .querySelector(".blm-product-search-sidebar")
        .classList.remove("visible");
      localStorage.setItem("blm-filter", "");
    } else {
      document
        .querySelector(plpSelectorResultsWithFacets)
        .classList.add("visible");
      document
        .querySelector(".blm-product-search-sidebar")
        .classList.add("visible");
      localStorage.setItem("blm-filter", "visible");
    }
  }

  document.addEventListener("click", (evt) => {
    if (
      evt.target.classList.contains(
        "blm-product-search-selected-filters__clear-all"
      )
    ) {
      const currentUrl = new URL(window.location.href);
      currentUrl.search = "";
      window.history.pushState({}, "", currentUrl.href);
      window.location.reload();
    }
  });
  setMobileFilterCloseButtonInCheckboxAndPriceRangeInputs();
}

function setProductResultHeight() {
  isElementLoaded(".with-facets").then(() => {
    setTimeout(() => {
      const results = document.querySelectorAll(
        ".blm-product-search__results .blm-product-search-swatch-image a"
      );
      results.forEach((el) => {
        const height = el.querySelector("img").offsetHeight;
        el.style.display = "block";
        el.style.minHeight = height + "px";
      });
    }, 20);
  });
}

function closeFilterOnLoad() {
  const filterButton = document.querySelector("button.filter-toggle-button");
  if (filterButton) {
    filterButton.click();
  }
}
function setMobileCloseFilterButton() {
  setTimeout(() => {
    if (window.innerWidth <= 768) {
      const closeButton = document.querySelector(
        ".blm-product-search-control-button--active"
      );
      closeButton.style.setProperty("display", "block", "important");
    }
  }, 1000);
}
function setMobileFilterCloseButtonInCheckboxAndPriceRangeInputs() {
  console.log("here setMobileFilterCloseButtonInCheckboxAndPriceRangeInputs");
  setTimeout(() => {
    const allFilterCheckboxes = document.querySelectorAll(
      ".blm-product-search-filter-item__checkbox"
    );
    const allFilterPriceRanges = document.querySelectorAll(
      ".blm-price-range-input"
    );

    function handleFilterClick(e) {
      setProductResultHeight();

      if (localStorage.getItem("blm-filter") === "visible") {
        document
          .querySelector(plpSelectorResultsWithFacets)
          .classList.remove("visible");
        document
          .querySelector(".blm-product-search-sidebar")
          .classList.remove("visible");
        localStorage.setItem("blm-filter", "");
      } else {
        document
          .querySelector(plpSelectorResultsWithFacets)
          .classList.add("visible");
        document
          .querySelector(".blm-product-search-sidebar")
          .classList.add("visible");
        localStorage.setItem("blm-filter", "visible");
      }
    }

    allFilterCheckboxes?.forEach((checkbox) => {
      checkbox.addEventListener("click", (e) => {
        setMobileCloseFilterButton();
        // setMobileFilterCloseButtonInCheckboxAndPriceRangeInputs();
        if (window.innerWidth <= 768) {
          const closeButton = document.querySelector(
            ".blm-product-search-control-button--active"
          );
          closeButton.click();
        } else {
          console.log("here else");
          setTimeout(() => {
            window.jQuery(plpSelectorResultsWithFacets).addClass("visible");
            window.jQuery(".blm-product-search-sidebar").addClass("visible");
            window
              .jQuery(".blm-category.blm-results.with-facets.visible")
              .removeAttr("style");
            window
              .jQuery(".blm-product-search-sidebar.visible")
              .removeAttr("style");
            localStorage.setItem("blm-filter", "visible");
            const button = document.querySelector(".filter-toggle-button");
            console.log("button =>", button);
            button.addEventListener("click", handleFilterClick, true);
          }, 2000);
        }
      });
    });

    allFilterPriceRanges?.forEach((priceRange) => {
      priceRange.addEventListener("change", () => {
        setMobileCloseFilterButton();
        setMobileFilterCloseButtonInCheckboxAndPriceRangeInputs();
        if (window.innerWidth <= 768) {
          const closeButton = document.querySelector(
            ".blm-product-search-control-button--active"
          );
          closeButton.click();
        } else {
          setTimeout(() => {
            window.jQuery(plpSelectorResultsWithFacets).addClass("visible");
            window.jQuery(".blm-product-search-sidebar").addClass("visible");
            window
              .jQuery(".blm-category.blm-results.with-facets.visible")
              .removeAttr("style");
            window
              .jQuery(".blm-product-search-sidebar.visible")
              .removeAttr("style");
            localStorage.setItem("blm-filter", "visible");
            const button = document.querySelector(".filter-toggle-button");
            button.addEventListener("click", handleFilterClick, true);
          }, 2000);
        }
      });
    });
  }, 1000);
}
